<div class="container">
  <div class="page-container">
    <div class="header-content">
      <h2>Manage Email Templates</h2>
    </div>
    <table aria-describedby="Email Templates" [dataSource]="dataSource" mat-table>
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell>Name</th>
        <td *matCellDef="let row" mat-cell>{{ row.name }}</td>
      </ng-container>
      <ng-container matColumnDef="subject">
        <th *matHeaderCellDef mat-header-cell>Subject</th>
        <td *matCellDef="let row" mat-cell>{{ row.subject }}</td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <th *matHeaderCellDef mat-header-cell>Description</th>
        <td *matCellDef="let row" mat-cell>{{ row.description }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th *matHeaderCellDef mat-header-cell>Actions</th>
        <td *matCellDef="let row" mat-cell>
          <button (click)="navigateToTemplateDetails(row)" color="primary" mat-stroked-button>View/Edit</button>
        </td>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  </div>
</div>
